import React from 'react';

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function CookiePolicyView() {
	return (
		<div>
			<h2 id="ga4-cookie-policy">Cookies and Similar Technologies</h2>
			<div>
				<p>We use cookies and similar technologies to collect and store information about your use of our Site. Cookies are small data files that are placed on your device when you visit a website. We use cookies for the following purposes:</p>
				<ul>
					<li>To operate and improve our Site</li>
					<li>To personalize your experience</li>
					<li>To analyze usage and trends</li>
					<li>To serve ads based on your interests</li>
				</ul>
				<p>You can control the use of cookies through your browser settings and other tools. However, if you disable cookies, you may not be able to use certain features of our Site.</p>
			</div>
		</div>
	);
}